/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const Rive72Icon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 72, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="Rive72Icon"
          width="72"
          height="72"
          viewBox="0 0 72 72"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path
              opacity="0.67"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18 19.3356C18 20.6249 19.0583 21.6706 20.3631 21.6706H39.9464C42.1784 21.6706 44.0165 22.3519 45.4605 23.7145C46.9046 25.077 47.6266 26.8284 47.6266 28.9693C47.6266 30.948 46.9046 32.5698 45.4598 33.8347C44.0164 35.0676 42.1784 35.6838 39.9464 35.6838H31.4355C30.13 35.6838 29.0717 36.7288 29.0717 38.0194C29.0717 39.3087 30.13 40.3544 31.4355 40.3544H40.8335L49.301 53.7833C49.826 54.5949 50.5644 55 51.516 55C52.5668 55 53.3051 54.5949 53.7317 53.7833C54.1583 52.9405 54.0761 52.0482 53.4858 51.1077L45.953 39.1377C47.988 38.2298 49.5965 36.8998 50.7777 35.1484C51.9595 33.3644 52.5505 31.305 52.5505 28.9693C52.5505 26.6011 52.0084 24.5254 50.9257 22.7414C49.8756 20.9568 48.3989 19.5623 46.495 18.5566C44.5911 17.5184 42.4087 17 39.9464 17H20.3638C19.0583 17 18 18.045 18 19.3356Z"
              fill="currentColor"
            />
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

Rive72Icon.category = '72x72 (File types)';

Rive72Icon.iconSize = 72;
